import Header from "@/components/landing/Header";
import HeroSection from "@/components/landing/HeroSection";
import ValuePropSection from "@/components/landing/ValuePropSection";
import CorePillarsSection from "@/components/landing/CorePillarsSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import FeatureGridSection from "@/components/landing/FeatureGridSection";
import WhyLumeroFlowSection from "@/components/landing/WhyLumeroFlowSection";
import PricingSection from "@/components/landing/PricingSection";
import PrivacySection from "@/components/landing/PrivacySection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import FAQSection from "@/components/landing/FAQSection";
import FinalCTASection from "@/components/landing/FinalCTASection";
import Footer from "@/components/landing/Footer";
import CookieBanner from "@/components/landing/CookieBanner";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ValuePropSection />
        <CorePillarsSection />
        <HowItWorksSection />
        <FeatureGridSection />
        <WhyLumeroFlowSection />
        <PricingSection />
        <PrivacySection />
        <TestimonialsSection />
        <FAQSection />
        <FinalCTASection />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
